import { apiClient } from './api-client';
import { ApiResponse, Question, ListQuestionsResponse } from '../types';

export const QuestionService = {
  /**
   * Get questions by note ID
   * @param noteId The ID of the note to get questions for
   * @returns Promise that resolves to an array of Question objects
   */
  async getQuestionsByNoteId(noteId: number): Promise<Question[]> {
    const response = await apiClient.get<ApiResponse<ListQuestionsResponse>>(
      `/questions/note/${noteId}`
    );
    return response.data.data.questions;
  },
  
  /**
   * Get a question by ID
   * @param id The ID of the question to retrieve
   * @returns Promise that resolves to a Question object
   */
  async getQuestionById(id: number): Promise<Question> {
    const response = await apiClient.get<ApiResponse<Question>>(`/questions/${id}`);
    return response.data.data;
  },

  /**
   * Create a new question
   * @param questionData The question data to create
   * @returns Promise that resolves to the created Question object
   */
  async createQuestion(questionData: { question: string, answer: string, note_id: number }): Promise<Question> {
    const response = await apiClient.post<ApiResponse<Question>>('/questions', questionData);
    return response.data.data;
  },
  
  /**
   * Update an existing question
   * @param id The ID of the question to update
   * @param questionData The question data to update
   * @returns Promise that resolves to the updated Question object
   */
  async updateQuestion(id: number, questionData: { question?: string, answer?: string }): Promise<Question> {
    const response = await apiClient.put<ApiResponse<Question>>(`/questions/${id}`, questionData);
    return response.data.data;
  },

  /**
   * Delete a question
   * @param id The ID of the question to delete
   * @returns Promise that resolves when the question is deleted
   */
  async deleteQuestion(id: number): Promise<void> {
    await apiClient.delete<ApiResponse<void>>(`/questions/${id}`);
  }
};